import React from 'react';

type Props = React.SVGProps<SVGSVGElement>;

const PepiconsPrintGiftIcon = (props: Props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={20} viewBox="0 0 20 20" {...props}>
      <g fill="currentColor">
        <path
          fillRule="evenodd"
          d="M20 8a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1z"
          clipRule="evenodd"
          opacity={0.2}
        ></path>
        <path
          fillRule="evenodd"
          d="M3 5h14a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1m14 12V6H3v11z"
          clipRule="evenodd"
        ></path>
        <path d="M9.5 5.5h1v12h-1z"></path>
        <path d="M2 10.5h16v1H2z"></path>
        <path
          fillRule="evenodd"
          d="M8.943 1.554c1.125.978 1.787 3.001 1.035 3.866c-.75.864-2.374.27-3.659-.847c-1.094-.951-1.469-2.399-.712-3.269c.756-.87 2.242-.701 3.336.25M6.975 3.82c.897.779 2.033 1.194 2.249.945c.3-.344-.174-1.792-.937-2.455c-.725-.63-1.595-.73-1.926-.349c-.33.38-.11 1.229.614 1.859"
          clipRule="evenodd"
        ></path>
        <path
          fillRule="evenodd"
          d="M11.298 1.554c-1.124.978-1.787 3.001-1.035 3.866c.75.864 2.374.27 3.66-.847c1.094-.951 1.469-2.399.712-3.269c-.756-.87-2.242-.701-3.337.25m1.969 2.265c-.897.779-2.033 1.194-2.249.945c-.3-.344.174-1.792.936-2.455c.725-.63 1.596-.73 1.926-.349c.33.38.111 1.229-.613 1.859"
          clipRule="evenodd"
        ></path>
      </g>
    </svg>
  );
};
export default PepiconsPrintGiftIcon;
